import { Injector, InjectionToken, Injectable } from '@angular/core';

export const INJECTOR_TOKEN = new InjectionToken<Injector>('INJECTOR_TOKEN');

@Injectable({
  providedIn: 'root'
})
export class InjectorService {
  private injector: Injector;

  constructor(private _injector: Injector) {
    this.injector = _injector;
  }

  get<T>(token: any, notFoundValue?: T): T {
    return this.injector.get<T>(token, notFoundValue);
  }
}

